import React, { useState } from 'react'
import { Input } from 'antd'
import { Box, IconButton, Paper, ToggleButton, ToggleButtonGroup } from '@mui/material'
import CloudUploadIcon from '@mui/icons-material/CloudUpload'
import LinkIcon from '@mui/icons-material/Link'
import CloseIcon from '@mui/icons-material/Close'

import { UploadZone } from '../BlockEditor/UploadZone'
import { IMAGE_MAX_SIZE } from '../BlockEditor/utils'

type InputMode = 'url' | 'upload'

interface ImageUrlInputProps {
  value?: string
  onChange?: (url: string) => void
  placeholder?: string
  disabled?: boolean
}

export function ImageUrlInput({
  value = '',
  onChange,
  placeholder = 'https://...',
  disabled,
}: ImageUrlInputProps) {
  const [mode, setMode] = useState<InputMode>(value ? 'url' : 'url')

  const handleUrlChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    onChange?.(e.target.value)
  }

  const handleUpload = (url: string) => {
    onChange?.(url)
    setMode('url')
  }

  const handleClear = () => {
    onChange?.('')
  }

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5 }}>
      <ToggleButtonGroup
        value={mode}
        exclusive
        onChange={(_, v) => v && setMode(v)}
        size="small"
        sx={{ alignSelf: 'flex-start' }}
      >
        <ToggleButton value="url">
          <LinkIcon sx={{ mr: 0.5, fontSize: 18 }} />
          URL
        </ToggleButton>
        <ToggleButton value="upload">
          <CloudUploadIcon sx={{ mr: 0.5, fontSize: 18 }} />
          อัพโหลด
        </ToggleButton>
      </ToggleButtonGroup>

      {mode === 'url' ? (
        <Box sx={{ display: 'flex', gap: 1, alignItems: 'flex-start' }}>
          <Input
            value={value}
            onChange={handleUrlChange}
            placeholder={placeholder}
            allowClear
            disabled={disabled}
            style={{ flex: 1 }}
          />
          {value && (
            <Paper
              variant="outlined"
              sx={{
                p: 1,
                display: 'flex',
                alignItems: 'center',
                gap: 1,
                flexShrink: 0,
              }}
            >
              <Box
                component="img"
                src={value}
                alt=""
                sx={{
                  width: 40,
                  height: 40,
                  borderRadius: 0.5,
                  objectFit: 'cover',
                  bgcolor: 'action.hover',
                }}
                onError={(e) => {
                  (e.target as HTMLImageElement).style.display = 'none'
                }}
              />
              <IconButton size="small" onClick={handleClear} disabled={disabled}>
                <CloseIcon fontSize="small" />
              </IconButton>
            </Paper>
          )}
        </Box>
      ) : (
        <UploadZone
          accept="image/*"
          color="#6EE7B7"
          icon={<CloudUploadIcon />}
          title="คลิกหรือลากไฟล์มาวาง"
          hint="PNG, JPG, WEBP, GIF — ไม่เกิน 10MB"
          maxSize={IMAGE_MAX_SIZE}
          onUpload={handleUpload}
          disabled={disabled}
        />
      )}
    </Box>
  )
}
